import React from "react";

import RevntLogo from "../../assets/logo.png";

export default function TwilioLogo(props: any) {
  return <img height="30" width="30" src={RevntLogo} {...props} />;
}
